export const FETCH_MANAGER_DOCUMENTS = 'fetch_manager_documents';
export const FETCH_MANAGER_DOCUMENTS_SUCCESS = 'fetch_manager_documents_success';
export const RESET_MANAGER_DOCUMENTS_SYNCING = 'reset_manager_documents_syncing';
export const UPLOAD_MANAGER_DOCUMENT = 'upload_manager_document';
export const UPLOAD_MANAGER_DOCUMENT_SUCCESS = 'upload_manager_document_success';

